import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BroadCastServiceService } from '@shared/services/broad-cast-service.service';
import storageService from '@shared/storage/storageService';
import { MatDialog } from "@angular/material/dialog";
import { ChangePasswordComponent } from '@app/auth/components/change-password/change-password.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.scss']
})
export class AboutUsComponent implements OnInit {
  sidenav_opened = false;
  subscription: any;
  isComponent: any;
  selectedLanguage: string;

  constructor( 
    private broadCast: BroadCastServiceService,
    private router: Router,
    public dialog: MatDialog,
		private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.setLanguage();
    this.subscription = this.broadCast.getMessage().subscribe((message) => {
      if (message) {
        this.isComponent = message;
        console.log("this.isComponent",this.isComponent);
      }
    });
  }

  setLanguage() {
		this.selectedLanguage = storageService.getItem("language");
		this.translate.use(this.selectedLanguage);
	}
  
  logout() {
    storageService.clearItem("token");
    storageService.clearItem("currentUser");
    storageService.clearItem("userId");
    this.router.navigate(["landing-page"]);
  }

  openChangePwdModel() {
    this.dialog.open(ChangePasswordComponent);
  }

  onClick(routeString){
    this.router.navigate([routeString]);
  }

  onMyAppoinment(routeStr){
    this.router.navigate([routeStr]);
  }
}
